<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'RecoverPassword',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Recover My Password'),
      email: '',
      invalid: [],
      isDisabled: false,
      isRecovering: false
    };
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    handleSubmit() {
      this.isRecovering = true;

      // Recover the user's password
      this.$http
        .post('/auth/password/recover', {
          email: this.email,
          message: {
            subject: this.$t('Reset Your Password'),
            intro: this.$t('You recently requested to reset the password for your {appName} account.', {
              appName: this.$store.state.metadata.appName
            }),
            callToAction: this.$t('Reset My Password'),
            outro: this.$t("If you didn't request this, you can safely ignore this message.")
          }
        })
        .then(() => {
          this.isDisabled = true;
          this.invalid = [];

          // Show a message, then redirect
          this.$notify({
            type: 'success',
            title: this.title,
            message: this.$t('Please check your email for further instructions.'),
            onClose: () => this.$router.push({ name: 'Login' })
          });
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: getErrorMessage(data.code)
            });
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isRecovering = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form
      ref="recoverForm"
      :disabled="isDisabled"
      label-position="top"
      @submit.native.prevent="handleSubmit"
    >
      <!-- Email -->
      <el-form-item :class="{ 'is-error': invalid.includes('email') }">
        <el-input
          ref="email"
          v-model="email"
          :placeholder="$t('Email')"
          prefix-icon="el-icon-fa-envelope"
          type="email"
          auto-complete="off"
        />
      </el-form-item>

      <!-- Recover button -->
      <el-form-item>
        <el-button
          :loading="isRecovering"
          type="primary"
          block
          native-type="submit"
          class="el-button--block"
        >
          {{ $t('Recover My Password') }}
        </el-button>
      </el-form-item>

      <!-- Cancel link -->
      <div class="text-center">
        <small>
          <router-link :to="{ name: 'Login' }">
            {{ $t('Cancel') }}
          </router-link>
        </small>
      </div>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
